// $cli-hook-boot-polyfills
require('babel-polyfill');
require('custom-event-polyfill');

Element.prototype.remove = function () {
    this.parentElement.removeChild(this);
};
NodeList.prototype.remove = HTMLCollection.prototype.remove = function () {
    for (let i = this.length - 1; i >= 0; i--) {
        if (this[i] && this[i].parentElement) {
            this[i].parentElement.removeChild(this[i]);
        }
    }
};



// WEBPACK FOOTER //
// ./resources/assets/js/boot/polyfills.js